module.exports = __webpack_public_path__ + "img/thumbnail_Raccoon_m_albino.1b1568d0.png";